import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './store/actions';
import { FusePageCarded } from '@fuse';
import { Grid, Table, TableHead, TableRow, TableCell, TableBody, Checkbox, Tab, Tabs } from '@material-ui/core';
import TabPanelButtons from '../../components/TabPanelButtons';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64,
        [theme.breakpoints.up('md')]: {
            minWidth: '144px'
        }
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
        minWidth: '80%',
        maxWidth: '80%'
    },
    subheaderRow: {
        backgroundColor: theme.palette.background.paper
    }
});

class Permission extends Component {
    state = {
        current_tab: 0
    }

    componentDidMount = () => {
        this.props.getPermissions();
        this.props.getAuthRoleList();
    }

    handleChangeTab = (event, value) => {
        this.setState({
            current_tab: value
        });
    }

    handleSubmit = () => {
        this.props.saveRolePermissions(this.props.permissionFullList);
    }

    handleChange = (permission_id, role_id, status) => {
        this.props.updateRolePermission(permission_id, role_id, Number(status));
    }

    getPageContent = () => {
        const { current_tab } = this.state;

        switch(current_tab)
        {
            case(0): // User Permissions
            {
                return this.getPermissionContent();
            }
            case(1): // User Side Panel
            {
                return this.getNavbarContent();
            }
        }
    }
    
    getPermissionContent = () => {
        const { permissionFullList, authRoleList, classes } = this.props;
        let current_component_name = '';

        return (
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Decription</TableCell>
                        {authRoleList.map((role_info) => (
                            <TableCell key={role_info.auth_role_id}>{role_info.RoleName}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {permissionFullList.filter((permission_info) => permission_info.PermissionType !== 'navbar' && permission_info.ComponentName !== 'utils').map((permission_info) => {
                        let table_rows = [];
                        if (permission_info.ComponentName !== current_component_name) {
                            current_component_name = permission_info.ComponentName;

                            table_rows.push(
                                <TableRow key={current_component_name} className={classes.subheaderRow}>
                                    <TableCell>{current_component_name.charAt(0).toUpperCase() + current_component_name.slice(1) + " Permissions"}</TableCell>
                                    {permission_info.ActiveRoleList.map((permission_role_info) => (
                                        <TableCell key={permission_role_info.role_id}></TableCell>
                                    ))}
                                </TableRow>
                            );
                        }

                        table_rows.push(
                            <TableRow key={permission_info.permission_id}>
                                <TableCell>{permission_info.PermissionDescription}</TableCell>
                                {permission_info.ActiveRoleList.map((permission_role_info) => (
                                    <TableCell key={permission_role_info.role_id}>
                                        <Checkbox
                                            checked={Boolean(permission_role_info.Active)}
                                            onChange={(event) => this.handleChange(permission_info.permission_id, permission_role_info.role_id, event.target.checked)}
                                        />
                                    </TableCell>
                                ))}
                            </TableRow>
                        );

                        return table_rows;
                    })}
                </TableBody>
            </Table>
        )
    }

    getNavbarContent = () => {
        const { permissionFullList, authRoleList } = this.props;

        return (
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Decription</TableCell>
                        {authRoleList.map((role_info) => (
                            <TableCell key={role_info.auth_role_id}>{role_info.RoleName}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {permissionFullList.filter((permission_info) => permission_info.PermissionType === 'navbar').map((permission_info) => (
                        <TableRow key={permission_info.permission_id}>
                            <TableCell>{permission_info.PermissionDescription}</TableCell>
                            {permission_info.ActiveRoleList.map((permission_role_info) => (
                                <TableCell key={permission_role_info.role_id}>
                                    <Checkbox
                                        checked={Boolean(permission_role_info.Active)}
                                        onChange={(event) => this.handleChange(permission_info.permission_id, permission_role_info.role_id, event.target.checked)}
                                    />
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        )
    }

    render() {
        const { classes }     = this.props;
        const { current_tab } = this.state;
        const page_content    = this.getPageContent();

        return (
            <FusePageCarded
                classes={{
                    root:    classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    <div className="py-24"><h4>Permissions Edit</h4></div>
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%', }}>
                        <Grid container>
                            <Tabs
                                value={current_tab}
                                onChange={this.handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{
                                    root: classes.tabsRoot
                                }}
                                scrollable={true}
                            >
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="User Permissions"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="User Side Panel"
                                />
                            </Tabs>
                            <TabPanelButtons
                                component_name = {"permission"}
                                view_type      = {"edit"}
                                button_list    = {[
                                    {
                                        display:  "Save",
                                        type:     "update",
                                        onClick:  this.handleSubmit,
                                    },
                                    {
                                        type:    "back",
                                        onClick: this.props.history.goBack,
                                    }
                                ]}
                            />
                        </Grid>
                    </div>
                }
                content={
                    <React.Fragment>
                        <div className="p-24">
                            {page_content}
                        </div>
                    </React.Fragment>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getPermissions:       Actions.getPermissions,
        getAuthRoleList:      Actions.getAuthRoleList,
        updateRolePermission: Actions.updateRolePermission,
        saveRolePermissions:  Actions.saveRolePermissions,
    }, dispatch);
}

function mapStateToProps({ auth, permissionApp }) {
    return {
        auth:               auth,
        permissionFullList: permissionApp.permissions.permissionFullList,
        authRoleList:       permissionApp.permissions.authRoleList,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Permission)));



// WEBPACK FOOTER //
// src/main/content/permission/Permission.js